export default "//yastatic.net/s3/distribution/pythia/frontend/_/69b4fede6ff5e82bd29936375e383051.svg";